"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const no_results_styles_1 = require("./no-results.styles");
const localization_1 = require("../../../localization");
const NoResults = ({ messageKey }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(no_results_styles_1.StyledNoResultsContainer, null, react_1.default.createElement("div", null, react_1.default.createElement(ui_components_1.SearchGraphic, null)), react_1.default.createElement("div", null, t({ key: messageKey || 'NO_DATA_AVAILABLE' }))));
};
exports.NoResults = NoResults;
exports.default = exports.NoResults;
